module.exports = __webpack_public_path__ + "static/media/videos.9acef043.svg";